export function ProgressBar({ done, total = 4 }: { done: number; total?: number }) {
  const pct = total > 0 ? (done / total) * 100 : 0;
  let cls: 'blue' | 'yellow' | 'green' = 'yellow';
  if (done === total) cls = 'green';
  if (done === 0) cls = 'blue';
  return (
    <div className="progress-wrap">
      <div className="progress-bar">
        <div className={`progress-fill ${cls}`} style={{ width: `${pct}%` }} />
      </div>
      <span className="progress-text">
        {done}/{total}
      </span>
    </div>
  );
}
